// ─────────────────────────────────────────────────────────────────────────────
// RangeSelect.js — the time-range dropdown in the Network Bandwidth card header.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./RangeSelect.module.css";

/**
 * @param {object}   props
 * @param {string}   props.value
 * @param {string[]} props.options
 * @param {(v: string) => void} props.onChange
 */
export default function RangeSelect({ value, options, onChange }) {
  return (
    <select
      className={styles.select}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Time range"
    >
      {options.map((v) => <option key={v}>{v}</option>)}
    </select>
  );
}
